import { FlowCard } from "./FlowCard";

// Matches Domain\LiftingCategoryCheck\LiftingCategoryOutcome (gateway-api).
export type LiftingCategory = "routine" | "niet_routine" | "kritisch";

export const liftingCategoryLabels: Record<LiftingCategory, string> = {
  routine: "Routine",
  niet_routine: "Niet routine",
  kritisch: "Kritisch",
};

export class Checklist {
  constructor(
    public readonly uuid: string,
    public readonly materialType: string,
    // null = for every lifting category; the app picks the checklist matching the run's lifting category.
    public readonly liftingCategory: LiftingCategory | null,
    // null = global (available to every company); a uuid scopes it to one specific company.
    public readonly companyUuid: string | null,
    // Number of steps that precede this checklist's first column: column 0 is step stepOffset + 1.
    public readonly stepOffset: number,
    public readonly cards: FlowCard[],
  ) {}

  get liftingCategoryLabel(): string {
    return this.liftingCategory ? liftingCategoryLabels[this.liftingCategory] : "Alle";
  }

  static fromJson(json: any): Checklist {
    return new Checklist(
      json["uuid"],
      json["material_type"],
      json["lifting_category"] ?? null,
      json["company_uuid"] ?? null,
      json["step_offset"] ?? 0,
      (json["cards"] ?? []).map((card: any) => FlowCard.fromJson(card)),
    );
  }
}
